import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { ReservationModel } from 'src/app/models/reservation.model';
import { MatIconModule } from '@angular/material/icon';
import { DescriptionService } from 'src/app/shared/services/description.service';

@Component({
  selector: 'app-reservation-detail-modal',
  standalone: true,
  imports: [MatDialogModule, CommonModule, MatIconModule],
  templateUrl: './reservation-detail-modal.component.html',
  styleUrl: './reservation-detail-modal.component.css'
})
export class ReservationDetailDialogComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: ReservationModel, private descriptionService: DescriptionService) { }

  paymentMethodLabel(paymentMethod: any): string {
    return this.descriptionService.paymentMethodLabel(paymentMethod);
  }
  documentTypeLabel(documentType: any): string {
    return this.descriptionService.documentTypeLabel(documentType);
  }

  paymentStatus(paymentStatus: any): { label: string; class: string } {
    return this.descriptionService.paymentStatus(paymentStatus);
  }

  reservationStatus(status: any): { label: string; class: string } {
    return this.descriptionService.reservationStatus(status);
  }
}

